import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

export function withRouter(Component) {
    function WrappedWithRouter(props) {
        const navigate = useNavigate();
        const location = useLocation();
        return <Component {...props} navigate={navigate} location={location} />;
    }
    WrappedWithRouter.displayName = `withRouter(${Component.displayName || Component.name || 'Component'})`;
    return WrappedWithRouter;
}
